module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_6_preview.6d183b0b.jpg";